(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[255],{

/***/ 52467:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/results",
      function () {
        return __webpack_require__(82952);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 82952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ results; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(10092);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./next-seo.config.js
var next_seo_config = __webpack_require__(5056);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
;// CONCATENATED MODULE: ./utils/results.js

var RESULTS_TITLE = "Newspage Results: real searches, real results";
var RESULTS_DESCRIPTION = "Dated examples of Newspage stories and sponsors' pages on page one of Google and in the AI Overview, searchable by sector.";
var ALL_SECTORS = "All";
var RESULT_TYPES = [
    "AI Overview",
    "Page one",
    "Sponsor's page"
];
var NUMBER_WORDS = [
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten",
    "eleven",
    "twelve", 
];
var _n;
var numberWord = function(n) {
    return (_n = NUMBER_WORDS[n]) !== null && _n !== void 0 ? _n : String(n);
};
var sectorsOf = function(cases) {
    return (0,_to_consumable_array/* default */.Z)(new Set(cases.map(function(c) {
        return c.sector;
    })));
};
var aiOverviewCount = function(cases) {
    return cases.filter(function(c) {
        return c.resultTags.includes("AI Overview");
    }).length;
};
// Every chosen result type must be on the case; the search runs over the visible text.
var filterCases = function(cases, param) {
    var sector = param.sector, types = param.types, query = param.query;
    var q = (query || "").trim().toLowerCase();
    return cases.filter(function(c) {
        return (sector === ALL_SECTORS || c.sector === sector) && types.every(function(t) {
            return c.resultTags.includes(t);
        }) && (!q || [
            c.sector,
            c.search,
            c.headline,
            c.detail,
            c.who
        ].join(" ").toLowerCase().includes(q));
    });
};

// EXTERNAL MODULE: ./styles/modules/Results.module.scss
var Results_module = __webpack_require__(34791);
var Results_module_default = /*#__PURE__*/__webpack_require__.n(Results_module);
;// CONCATENATED MODULE: ./components/Results/ResultsList.js





var Chip = function(param) {
    var label = param.label, pressed = param.pressed, type = param.type, onClick = param.onClick;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
        type: "button",
        className: [
            (Results_module_default()).chip,
            type ? (Results_module_default()).chipType : ""
        ].join(" "),
        "aria-pressed": pressed ? "true" : "false",
        onClick: onClick,
        children: label
    });
};
var Case = function(param) {
    var item = param.item;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
        className: (Results_module_default())["case"],
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Results_module_default()).meta,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Results_module_default()).sector,
                        children: item.sector
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                        children: [
                            "Seen on Google UK ",
                            item.dateSeen
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Results_module_default()).search,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                        children: "The search"
                    }),
                    "“",
                    item.search,
                    "”"
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                children: item.headline
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                children: item.detail
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("dl", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                        children: "Who"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                        children: item.who
                    }),
                    item.howFast && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dt", {
                                children: "How fast"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("dd", {
                                children: item.howFast
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Results_module_default()).tags,
                children: item.resultTags.map(function(tag) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: (Results_module_default()).tag,
                        children: tag
                    }, tag);
                })
            }),
            item.links.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (Results_module_default()).links,
                children: item.links.map(function(link) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                        href: link.url,
                        target: "_blank",
                        rel: "noopener",
                        children: [
                            link.label,
                            " →"
                        ]
                    }, link.url);
                })
            })
        ]
    });
};
// The first render lists every case, so the server HTML carries all of them without JS.
var ResultsList = function(param) {
    var cases = param.cases;
    var ref = (0,react.useState)(ALL_SECTORS), sector = ref[0], setSector = ref[1];
    var ref1 = (0,react.useState)([]), types = ref1[0], setTypes = ref1[1];
    var ref2 = (0,react.useState)(""), query = ref2[0], setQuery = ref2[1];
    var shown = filterCases(cases, {
        sector: sector,
        types: types,
        query: query
    });
    var toggleType = function(type) {
        return setTypes(RESULT_TYPES.filter(function(t) {
            return t === type ? !types.includes(t) : types.includes(t);
        }));
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Results_module_default()).bar,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("label", {
                        htmlFor: "results-q",
                        className: (Results_module_default()).hidden,
                        children: "Search the examples"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                        id: "results-q",
                        className: (Results_module_default()).input,
                        type: "search",
                        placeholder: "Search by topic, search term or firm, e.g. RSU, bridging, Heron",
                        autoComplete: "off",
                        value: query,
                        onChange: function(e) {
                            return setQuery(e.target.value);
                        }
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Results_module_default()).chips,
                        role: "group",
                        "aria-label": "Filter by sector",
                        children: [
                            ALL_SECTORS
                        ].concat((0,_to_consumable_array/* default */.Z)(sectorsOf(cases))).map(function(s) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip, {
                                label: s,
                                pressed: s === sector,
                                onClick: function() {
                                    return setSector(s);
                                }
                            }, s);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Results_module_default()).chips,
                        role: "group",
                        "aria-label": "Filter by result",
                        children: RESULT_TYPES.map(function(t) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Chip, {
                                label: t,
                                type: true,
                                pressed: types.includes(t),
                                onClick: function() {
                                    return toggleType(t);
                                }
                            }, t);
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (Results_module_default()).count,
                        "aria-live": "polite",
                        children: "Showing ".concat(shown.length, " of ").concat(cases.length, " examples")
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ol", {
                className: (Results_module_default()).list,
                children: shown.length ? shown.map(function(item) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Case, {
                        item: item
                    }, "".concat(item.search, "|").concat(item.dateSeen));
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                    className: (Results_module_default()).empty,
                    children: "No examples match. Try another sector or search term."
                })
            })
        ]
    });
};
/* harmony default export */ var Results_ResultsList = (ResultsList);

;// CONCATENATED MODULE: ./pages/results.js











var EMAIL = "editors@newspage.media";
var CopyEmail = function() {
    var ref = (0,react.useState)("Copy"), label = ref[0], setLabel = ref[1];
    var code = (0,react.useRef)(null);
    var copy = function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function() {
            var e, range, selection;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText(EMAIL)
                        ];
                    case 1:
                        _state.sent();
                        setLabel("Copied");
                        return [
                            3,
                            3
                        ];
                    case 2:
                        e = _state.sent();
                        range = document.createRange();
                        range.selectNodeContents(code.current);
                        selection = window.getSelection();
                        selection.removeAllRanges();
                        selection.addRange(range);
                        setLabel("Selected");
                        return [
                            3,
                            3
                        ];
                    case 3:
                        setTimeout(function() {
                            return setLabel("Copy");
                        }, 2000);
                        return [
                            2
                        ];
                }
            });
        });
        return function copy() {
            return _ref.apply(this, arguments);
        };
    }();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Results_module_default()).mail,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("code", {
                ref: code,
                children: EMAIL
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                type: "button",
                onClick: copy,
                children: label
            })
        ]
    });
};
var Results = function(param) {
    var cases = param.cases;
    var url = "".concat("https://app.newspage.media", "/results");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (Results_module_default()).page,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, next_seo_config/* default */.Z), {
                title: RESULTS_TITLE,
                titleTemplate: "%s",
                description: RESULTS_DESCRIPTION,
                canonical: url,
                openGraph: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, next_seo_config/* default.openGraph */.Z.openGraph), {
                    title: RESULTS_TITLE,
                    description: RESULTS_DESCRIPTION,
                    url: url
                })
            })),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (Results_module_default()).wrap,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (Results_module_default()).kick,
                        children: "Results"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        children: "Real searches. Real results. Dated."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        className: (Results_module_default()).lede,
                        children: [
                            "Every example below is a ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "Newspage story"
                            }),
                            ", or a",
                            " ",
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                children: "sponsor's own page"
                            }),
                            " linked from one, appearing on page one of Google or in Google's AI Overview for a search people actually make. Each one was seen on Google UK by the Newspage team and logged with the date and time."
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: (Results_module_default()).facts,
                        "aria-label": "Summary",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: cases.length
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            "examples across",
                                            " ",
                                            numberWord(sectorsOf(cases).length),
                                            " sectors"
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: aiOverviewCount(cases)
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "cited in Google's AI Overview"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                        children: "42 min"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "fastest, from publication to page one"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (Results_module_default()).how,
                        children: "How to read these: each result is what Google showed at the time stated, checked in a private window. Search results move, especially for news, so a position on one day is not a promise for the next. The screenshots are held by Newspage and available on request."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Results_ResultsList, {
                        cases: cases
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                        className: (Results_module_default()).cta,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                children: "Want this for your search?"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                children: "Sponsor a Newspage alert or story and the story links to your page for the search you choose. We can also give your page instructions so Google and the AI Overview can read it properly. Newspage's developers can make the changes for you if needed."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CopyEmail, {})
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (Results_module_default()).footnote,
                        children: "Newspage. Be trusted. Be visible. Be the story. \xb7 Results logged by Newspage, October to November 2026."
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ var results = (Results);


/***/ }),

/***/ 34791:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"page":"Results_page__a_ST9","wrap":"Results_wrap__fb7bE","kick":"Results_kick__kCJFZ","lede":"Results_lede__o7oU6","facts":"Results_facts__jgRub","how":"Results_how__2gx0g","bar":"Results_bar__t_v_a","hidden":"Results_hidden__VPd35","input":"Results_input__SAogD","chips":"Results_chips__sPlhk","chip":"Results_chip__ga4bf","chipType":"Results_chipType__eWDfb","count":"Results_count__qY2Vj","list":"Results_list__nFcOE","case":"Results_case__LkGjD","meta":"Results_meta__ZUuN2","sector":"Results_sector__tDEEZ","search":"Results_search__rfjOs","tags":"Results_tags__8SlIQ","tag":"Results_tag__UsLZK","links":"Results_links__S7Sxh","empty":"Results_empty__P_z7f","cta":"Results_cta__1BDio","mail":"Results_mail__9hYDN","footnote":"Results_footnote__y3cie"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(52467); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);